import Box from "@/common/components/Box";
import NegotiatingProductItemShow from "./NegotiatingProductItem";
import { NegotiationProductData } from "../../types/negotiations.type";
import { CompanyData } from "@/common/types/companies/companies.type";

interface NegotiatingProductsShowProps {
  negotiationProducts?: NegotiationProductData[];
  clientCompany?: CompanyData;
}

const NegotiatingProductsShow = ({ negotiationProducts, clientCompany: clientCompany }: NegotiatingProductsShowProps) => {
  return (
    <Box className="flex flex-col gap-4">
      <p>Produtos em negociação</p>

      {negotiationProducts?.map((negotiationProduct, index) => (
        <NegotiatingProductItemShow
          key={negotiationProduct.id}
          index={index}
          negotiationProduct={negotiationProduct}
          clientCompany={clientCompany}
        />
      ))}
    </Box>
  );
};

export default NegotiatingProductsShow;
